module.exports = __webpack_public_path__ + "img/w7.d6db633c.png";